'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TeamMember = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    & > div {\n        background-color: #efba50;\n        text-transform: initial;\n    }\n'], ['\n    & > div {\n        background-color: #efba50;\n        text-transform: initial;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background-color: #E8EBED;\n    text-align: center;\n    padding: 2em;\n    position: relative;\n\n    & > ', ' {\n        & > img {\n            border-radius: 50%;\n            max-width: 100%;\n        }\n        & > img:nth-child(2) {\n            display: none;\n        }\n        &:hover {\n            & > img:nth-child(1) {\n                display: none;\n            }\n            & > img:nth-child(2) {\n                display: block;\n            }\n        }\n    }\n    & > i {\n        color: #24a9bd;\n    }\n'], ['\n    background-color: #E8EBED;\n    text-align: center;\n    padding: 2em;\n    position: relative;\n\n    & > ', ' {\n        & > img {\n            border-radius: 50%;\n            max-width: 100%;\n        }\n        & > img:nth-child(2) {\n            display: none;\n        }\n        &:hover {\n            & > img:nth-child(1) {\n                display: none;\n            }\n            & > img:nth-child(2) {\n                display: block;\n            }\n        }\n    }\n    & > i {\n        color: #24a9bd;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Ribbon = require('./Ribbon');

var _HoverReveal = require('./HoverReveal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LeftRibbon = (0, _styledComponents2.default)(_Ribbon.Ribbon).attrs({
    left: true
})(_templateObject);

var TeamMember = exports.TeamMember = (0, _styledComponents2.default)(function (props) {
    return _react2.default.createElement(
        'div',
        { className: props.className },
        props.badge && _react2.default.createElement(
            LeftRibbon,
            null,
            props.badge
        ),
        _react2.default.createElement(
            _HoverReveal.HoverReveal,
            null,
            _react2.default.createElement('img', { src: props.pics[0], alt: props.name }),
            _react2.default.createElement('img', { src: props.pics[1], alt: props.name })
        ),
        _react2.default.createElement(
            'h3',
            null,
            props.name
        ),
        _react2.default.createElement(
            'i',
            null,
            props.role
        )
    );
})(_templateObject2, _HoverReveal.HoverReveal);
TeamMember.displayName = 'TeamMember';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/TeamMember.js
// module id = 646
// module chunks = 0